import SurveyForm from '@/pages/Surveys/SurveyForm.vue'
import AddSurvey from '../../../pages/Admin/Surveys/AddSurvey.vue'
import ShareSurvey from '../../../pages/Admin/Surveys/ShareSurvey.vue'
import SurveyList from '../../../pages/Admin/Surveys/SurveyList.vue'
import MySubmissions from '../../../pages/Admin/Surveys/MySubmissions.vue'
import SurveyResults from '../../../pages/Admin/Surveys/SurveyResults.vue'
import MySurveyResults from '../../../pages/Admin/Surveys/MySurveyResults.vue'
import SurveyAnalytics from '../../../pages/Admin/Surveys/SurveyAnalytics.vue'
import PublicSurveyForm from '../../../pages/Surveys/PublicSurveyForm.vue'
import SurveyListShared from '../../../pages/Admin/Surveys/SurveyListShared.vue'
import SurveyAnalyticsShared from '../../../pages/Admin/Surveys/SurveyAnalyticsShared.vue'


export default [
	{
		path: '/survey-form',
		name: 'survey-form',
		component: SurveyForm,
		meta: {
			secure: true
		}
    },
    {
		path: '/public-survey-form',
        name: 'public-survey-form',
        component: PublicSurveyForm,
		meta: {
			secure: false
		}
	},
    {
        name: 'add-survey',
        path: '/add-survey',
        component: AddSurvey,
        meta: {
            secure: true
        }
    },
    {
        name: 'share-survey',
        path: '/share-survey',
        component: ShareSurvey,
        meta: {
            secure: true
        }
    },
    {
        name: 'survey-list',
        path: '/survey-list',
        component: SurveyList,
        meta: {
            secure: true
        }
    },
    {
        name: 'survey-results',
        path: '/survey-results',
        component: SurveyResults,
        meta: {
            secure: true
        }
    },
    {
        name: 'my-survey-results',
        path: '/my-survey-results',
        component: MySurveyResults,
        meta: {
            secure: true
        }
    },
    {
        name: 'survey-analytics',
        path: '/survey-analytics',
        component: SurveyAnalytics,
        meta: {
            secure: true
        }
    },
    {
        name: 'my-submissions',
        path: '/my-submissions',
        component: MySubmissions,
        meta: {
            secure: true
        }
    },
    {
        name: 'survey-listShared',
        path: '/survey-listShared',
        component: SurveyListShared,
        meta: {
            secure: true
        }
    },
    {
        name: 'survey-analyticsShared',
        path: '/survey-analyticsShared',
        component: SurveyAnalyticsShared,
        meta: {
            secure: true
        }
    }
]